import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { axiosOpen } from "../../api/axios";
import { useNavigate } from "react-router-dom";
import "./SubscriptionPlanList.scss";
const SubscriptionPlanList = () => {
  // get data via axios
  const navigate = useNavigate();
  const [pageLoader, setPageLoader] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);
  const [planList, setPlanList] = useState(null);
  const fetchPlanDetails = async () => {
    const response = await axiosOpen.get("/api/subscription/list");
    console.log("data : ", response?.data);
    setPlanList(response?.data);
    setDataLoader(false);
  };
  useEffect(() => {
    fetchPlanDetails();
  }, []);

  return (
    <div className="subscription-plans-list">
      <Container>
        <Row>
          <div className="section-title text-center pb-4">
            <h2>Choose a Plan</h2>
            <p>Find one that works for you</p>
          </div>
          {planList ? (
            <>
              {planList.map((plan) => (
                <Col key={plan._id} md={4} className="mb-4">
                  <div className="plan-card p-4">
                    <div>
                      <h5 className="card-title">{plan.name}</h5>
                      <p className="price">
                        ${plan.amount} <span className="interval">/{plan.interval}</span>
                      </p>
                      <ul className="features px-4">
                        <li>{plan.description}</li>
                      </ul>
                    </div>
                    <Button
                      onClick={() => {
                        return false;
                        navigate(`/payment?planId=${plan._id}`, { replace: true });
                      }}
                      variant="primary"
                      className="subscribe-btn"
                      disabled
                    >
                      Active
                    </Button>
                  </div>
                </Col>
              ))}
            </>
          ) : (
            <div className="d-flex justify-content-center align-items-center h-100">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default SubscriptionPlanList;
